import "./footer.style.css";

const Footer = () => {
  return (
    <footer>
      <div className="con-footer">
        <div className="info">
          <span>Condition of Use</span>
          <span>Privacy & Policy</span>
          <span>Press Room </span>
        </div>
        <div className="ack">
          <span>2021 MovieBox by xGiye. Design by Adriana Eka Prayudha</span>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
